// Loading placeholder: grey bars in the shape of the coming content. Screen readers hear the label
// once (role="status"); the bars themselves are hidden from them.
const DEFAULT_LINES = 3;

export function Skeleton(props: {
  readonly lines?: number;
  readonly label?: string;
}): React.JSX.Element {
  const count = Math.max(1, props.lines ?? DEFAULT_LINES);
  return (
    <div className="skeleton" role="status" aria-busy="true">
      <span className="visually-hidden">{props.label ?? 'Loading…'}</span>
      {Array.from({ length: count }, (_, i) => (
        <span key={i} className="skeleton__bar" aria-hidden="true" />
      ))}
    </div>
  );
}
